export const FIRM = {
  name: "CM Ocenia Trust Ltd",
  reg: "068792",
  address: ["Rue de la Paix", "Quartier Cala Kuu", "Moroni, Grande Comore", "Union des Comores"],
  offices: [
    { id: "grande-comore", island: "Grande Comore", head: true, lines: ["Rue de la Paix", "Quartier Cala Kuu", "Moroni"], q: "Rue de la Paix, Cala Kuu, Moroni, Comoros" },
    { id: "anjouan", island: "Anjouan", lines: ["Rue de la Médina", "Quartier Pagé", "Mutsamudu"], q: "Mutsamudu, Anjouan, Comoros" },
    { id: "moheli", island: "Mohéli", lines: ["Avenue de l'Indépendance", "Quartier Salamani", "Fomboni"], q: "Fomboni, Moheli, Comoros" },
  ],
  email: "support@cmoceniatrust.com",
  web: "cmoceniatrust.com",
};

export const T = {
  en: {
    nav: { about: "About", practice: "Practice Areas", contact: "Contact" },
    hero: {
      eyebrow: "Law Firm & Trust Services — Moroni, Grande Comore",
      lines: ["Counsel built", "on principle,", "grounded in law."],
      lead: "CM Ocenia Trust Ltd provides legal and fiduciary counsel to individuals, companies and institutions in the Union of the Comoros.",
      cta: "Our practice areas",
      cta2: "Contact the firm",
      reg: "Registration No.",
    },
    marquee: ["Corporate Law", "Trusts & Fiduciary", "Commercial Contracts", "Banking & Finance", "Real Estate", "Dispute Resolution"],
    status: [
      { k: "Registered company", v: "Incorporated in the Union of the Comoros — N° 068792" },
      { k: "Where we operate", v: "Grande Comore, Anjouan and Mohéli" },
      { k: "Applicable law", v: "Services provided under the laws of the Union of the Comoros" },
    ],
    about: {
      label: "01 — About the Firm",
      title: "A firm of record in the Union of the Comoros.",
      p1: "Headquartered in Moroni, Grande Comore, with offices in Mutsamudu (Anjouan) and Fomboni (Mohéli), CM Ocenia Trust Ltd advises on matters of company law, trusts and commercial affairs under Comorian law.",
      p2: "We work with discretion, precision and respect for the institutions we serve. Each matter is handled directly, with clear advice and careful documentation.",
      values: [
        { k: "Integrity", v: "Independent advice, free of conflicts of interest." },
        { k: "Discretion", v: "Strict confidentiality in every client relationship." },
        { k: "Rigour", v: "Thorough research and carefully drafted documents." },
      ],
      caption: "Grande Comore · Anjouan · Mohéli",
    },
    practice: {
      label: "02 — Practice Areas",
      title: "Areas of practice",
      intro: "Legal and fiduciary services for private clients, businesses and institutions — available at our offices in Grande Comore, Anjouan and Mohéli.",
      items: [
        { t: "Corporate & Company Law", d: "Company formation, registration, governance, corporate secretarial services and restructuring." },
        { t: "Trusts & Fiduciary Services", d: "Establishment and administration of trusts, asset protection and estate planning." },
        { t: "Commercial Contracts", d: "Drafting, review and negotiation of commercial, supply and service agreements." },
        { t: "Banking & Finance", d: "Regulatory advice, licensing support and compliance for financial activities." },
        { t: "Real Estate & Property", d: "Property acquisitions, leases, title verification and land matters." },
        { t: "Dispute Resolution", d: "Pre-litigation advice, negotiation, mediation and representation of client interests." },
      ],
    },
    contact: {
      label: "03 — Contact",
      title: "Visit or write to our offices.",
      intro: "Appointments are available by prior arrangement.",
      address: "Our offices",
      head: "Head office",
      branch: "Office",
      email: "Email",
      hours: "Office hours",
      hoursV: ["Monday – Thursday: 8:00 – 16:00", "Friday: 8:00 – 12:00"],
      map: "Open in Google Maps",
      regTitle: "Registered company",
    },
    footer: { rights: "All rights reserved.", top: "Back to top" },
  },
  fr: {
    nav: { about: "Le Cabinet", practice: "Domaines", contact: "Contact" },
    hero: {
      eyebrow: "Cabinet juridique & services fiduciaires — Moroni, Grande Comore",
      lines: ["Un conseil fondé", "sur des principes,", "ancré dans le droit."],
      lead: "CM Ocenia Trust Ltd accompagne particuliers, entreprises et institutions en Union des Comores en matière juridique et fiduciaire.",
      cta: "Nos domaines d'expertise",
      cta2: "Contacter le cabinet",
      reg: "N° d'immatriculation",
    },
    marquee: ["Droit des sociétés", "Trusts & fiducie", "Contrats commerciaux", "Banque & finance", "Immobilier", "Règlement des litiges"],
    status: [
      { k: "Société immatriculée", v: "Constituée en Union des Comores — N° 068792" },
      { k: "Zones d'activité", v: "Grande Comore, Anjouan et Mohéli" },
      { k: "Droit applicable", v: "Services fournis conformément au droit de l'Union des Comores" },
    ],
    about: {
      label: "01 — Le Cabinet",
      title: "Un cabinet établi en Union des Comores.",
      p1: "Siégé à Moroni (Grande Comore), avec des bureaux à Mutsamudu (Anjouan) et Fomboni (Mohéli), CM Ocenia Trust Ltd conseille en droit des sociétés, en trusts et en affaires commerciales selon le droit comorien.",
      p2: "Nous travaillons avec discrétion, précision et respect des institutions. Chaque dossier est traité directement, avec des conseils clairs et une documentation rigoureuse.",
      values: [
        { k: "Intégrité", v: "Un conseil indépendant, sans conflit d'intérêts." },
        { k: "Discrétion", v: "Une stricte confidentialité dans chaque relation client." },
        { k: "Rigueur", v: "Des recherches approfondies et des actes soigneusement rédigés." },
      ],
      caption: "Grande Comore · Anjouan · Mohéli",
    },
    practice: {
      label: "02 — Domaines d'expertise",
      title: "Domaines d'intervention",
      intro: "Services juridiques et fiduciaires pour particuliers, entreprises et institutions — disponibles dans nos bureaux de Grande Comore, d'Anjouan et de Mohéli.",
      items: [
        { t: "Droit des sociétés", d: "Constitution, immatriculation, gouvernance, secrétariat juridique et restructuration de sociétés." },
        { t: "Trusts & services fiduciaires", d: "Constitution et administration de trusts, protection d'actifs et planification successorale." },
        { t: "Contrats commerciaux", d: "Rédaction, révision et négociation de contrats commerciaux, d'approvisionnement et de services." },
        { t: "Banque & finance", d: "Conseil réglementaire, accompagnement aux agréments et conformité des activités financières." },
        { t: "Immobilier & foncier", d: "Acquisitions, baux, vérification des titres et questions foncières." },
        { t: "Règlement des litiges", d: "Conseil précontentieux, négociation, médiation et défense des intérêts du client." },
      ],
    },
    contact: {
      label: "03 — Contact",
      title: "Rendez-nous visite ou écrivez-nous.",
      intro: "Rendez-vous possibles sur demande préalable.",
      address: "Nos bureaux",
      head: "Siège",
      branch: "Bureau",
      email: "E-mail",
      hours: "Horaires",
      hoursV: ["Lundi – jeudi : 8h00 – 16h00", "Vendredi : 8h00 – 12h00"],
      map: "Ouvrir dans Google Maps",
      regTitle: "Société immatriculée",
    },
    footer: { rights: "Tous droits réservés.", top: "Haut de page" },
  },
};
